import { type RefObject, useCallback, useEffect } from 'react';

interface UsePayboxAnimationProps {
    iframeRef: RefObject<HTMLIFrameElement | null>;
    nativePayEnabled: boolean;
    payboxSrc: string;
}

export const usePayboxAnimation = (props: UsePayboxAnimationProps) => {
    const { iframeRef, nativePayEnabled, payboxSrc } = props;

    const disableAnimation = useCallback(() => {
        iframeRef.current?.style.setProperty('transition', 'none');
    }, [iframeRef]);

    useEffect(() => {
        if (nativePayEnabled) {
            iframeRef.current?.style.setProperty('transition', 'height 150ms ease-in-out, margin 150ms ease-in-out');
        }
    }, [iframeRef, nativePayEnabled]);

    useEffect(() => {
        const iframe = iframeRef.current;

        iframe?.addEventListener('transitionend', disableAnimation);

        return () => {
            iframe?.removeEventListener('transitionend', disableAnimation);
        };
    }, [disableAnimation, iframeRef, nativePayEnabled, payboxSrc]);
};
